import {
  LOGIN_SUCCESS,
  AUTH_ERROR,
  LOGOUT,
  USER_LOADED,
  PERMISSIONS_LOADED,
  SET_LOADING,
  SET_LOADED,
  PASSWORD_CHANGE,
  RESET_SUCCESS,
  RESET_FAILED,
  VERIFY_TOKEN_FAILED,
  VERIFY_TOKEN_SUCCESS
} from "../actions/types";

const initialState = {
  token: localStorage?.token,
  instance: localStorage?.instance,
  authenticated: null,
  loading: true,
  user: null,
  permissions: []
};
function authReducer(state = initialState, action) {
  const { type, payload } = action;
  let result = { ...state }; // Create a copy of the state to avoid direct mutation

  switch (type) {
    case PERMISSIONS_LOADED:
      result.permissions = Array.isArray(payload) ? [...payload] : [];
      break;
    
    case USER_LOADED:
      result.authenticated = true;
      result.user = payload;
      result.loading = false;
      break;
    
    case LOGIN_SUCCESS:
    case PASSWORD_CHANGE:
      result.authenticated = true;
      result.loading = false;
      result = { ...result, ...payload }; // Merge payload with the result
      break;

    case AUTH_ERROR:
    case LOGOUT:
      result.authenticated = false;
      result.token = null;
      result.user = null;
      result.loading = false;
      break;

    case SET_LOADING:
      result.loading = true;
      break;

    case SET_LOADED:
      result.loading = false;
      break;

    case RESET_FAILED:
    case VERIFY_TOKEN_FAILED:
      result.loading = false;
      result.next = type === RESET_FAILED ? null : "forgot";
      result.token = type === VERIFY_TOKEN_FAILED ? null : result.token;
      break;

    case VERIFY_TOKEN_SUCCESS:
      result.loading = false;
      result.forward = false;
      result.next = null;
      break;

    case RESET_SUCCESS:
      result.loading = false;
      result.next = "login";
      break;
    default:
      break;
  }

  return result;
}

export default authReducer;
